var alt;

alt = new Alt();

module.exports = alt;
